var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.522,
    height: 175.164,
    viewBox: "0 0 324.522 175.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d9e9fe;}.b{fill:#fb7369;}.c{fill:#f2564b;}.d{fill:#3a4ace;}.e{fill:#a6c7f9;}.f{fill:#fc9490;}.g{fill:#ff8585;}.h{fill:#a9453d;}.i{fill:#2c3a64;}.j{fill:#293eb7;}.k{fill:#1e3d70;}.l{fill:#2a4e96;}.m{fill:#2e3552;}.n{fill:#3566c9;}.o{fill:#6d89d0;}.p{fill:#739af0;}.q{fill:#f48484;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1911.279 -768.209)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1905.946 768.209)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2009.171,990.4s-31.217-33.517-5.279-69.8c23.013-32.2,49.845-30,69.531-16.93,8.384,5.565,32.557.686,53.132-32.075,28.058-44.677,125.317-17.58,107.584,51.156-8.582,33.264,26.117,34.473,8.438,67.723Z",
    transform: "translate(-1978.745 -815.578)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.484 56.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 38.82,
    height: 38.82,
    transform: "matrix(0.725, -0.688, 0.688, 0.725, 0, 26.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7.818,
    height: 38.82,
    transform: "matrix(0.725, -0.688, 0.688, 0.725, 22.489, 5.381)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.945 14.004) rotate(82)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 55.676,
    height: 55.676,
    transform: "matrix(0.725, -0.688, 0.688, 0.725, 0, 38.322)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.327 89.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 38.82,
    height: 38.82,
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 0, 8.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 38.82,
    height: 7.818,
    transform: "translate(0 8.06) rotate(-11.983)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.119 88.513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.916)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3306.1,1010.572l-.621-.515a1.565,1.565,0,0,1-.206-2.2l4.321-5.212a1.564,1.564,0,0,1,2.2-.205l.89.738a.306.306,0,1,1-.39.471l-.89-.738a.952.952,0,0,0-1.339.125l-4.321,5.212a.951.951,0,0,0,.125,1.339l.621.515a.951.951,0,0,0,1.338-.125l2.869-3.46a.306.306,0,1,1,.471.39l-2.869,3.46A1.564,1.564,0,0,1,3306.1,1010.572Z",
    transform: "translate(-3304.914 -1002.081)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3262.354,1024.385l-1.114-.923a2.53,2.53,0,0,1-.209-3.563l6.5-7.835a.306.306,0,0,1,.471.39l-6.5,7.836a1.919,1.919,0,0,0,.129,2.7l1.113.923a1.919,1.919,0,0,0,2.68-.374l7.4-8.925a1.92,1.92,0,0,0-.129-2.7.306.306,0,0,1,.39-.471,2.53,2.53,0,0,1,.209,3.563l-7.4,8.925A2.53,2.53,0,0,1,3262.354,1024.385Z",
    transform: "translate(-3260.4 -1011.372)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.995 59.312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.288)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2590.05,1088.882l-.69.418a1.564,1.564,0,0,1-2.146-.526l-3.509-5.79a1.564,1.564,0,0,1,.527-2.146l.988-.6a.306.306,0,0,1,.317.523l-.988.6a.952.952,0,0,0-.32,1.306l3.509,5.79a.952.952,0,0,0,1.306.32l.69-.418a.952.952,0,0,0,.32-1.306l-2.329-3.844a.306.306,0,0,1,.523-.317l2.329,3.844A1.564,1.564,0,0,1,2590.05,1088.882Z",
    transform: "translate(-2583.479 -1080.195)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.462)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2597.658,1092.3l-1.237.75a2.531,2.531,0,0,1-3.436-.969l-5.275-8.7a.306.306,0,1,1,.523-.317l5.275,8.7a1.92,1.92,0,0,0,2.6.763l1.237-.75a1.92,1.92,0,0,0,.525-2.654l-6.01-9.915a1.919,1.919,0,0,0-2.6-.763.306.306,0,0,1-.317-.523,2.53,2.53,0,0,1,3.435.969l6.009,9.915A2.53,2.53,0,0,1,2597.658,1092.3Z",
    transform: "translate(-2587.666 -1077.592)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.386 22.345) rotate(82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.423,12.459l-.99.6A2.243,2.243,0,0,1,5.356,12.3L.324,4A2.243,2.243,0,0,1,1.079.923L2.5.064a.438.438,0,1,1,.455.75l-1.417.859a1.365,1.365,0,0,0-.459,1.873l5.032,8.3a1.365,1.365,0,0,0,1.873.459l.99-.6a1.365,1.365,0,0,0,.459-1.873L6.088,4.323a.438.438,0,0,1,.75-.454l3.341,5.512A2.243,2.243,0,0,1,9.423,12.459Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.663 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.331,21.1l-1.774,1.075a3.629,3.629,0,0,1-4.927-1.39L.063,8.3a.439.439,0,0,1,.75-.454L8.38,20.328A2.753,2.753,0,0,0,12.1,21.423l1.774-1.075a2.753,2.753,0,0,0,.752-3.807L6.01,2.321A2.753,2.753,0,0,0,2.287,1.226a.438.438,0,1,1-.454-.75A3.628,3.628,0,0,1,6.76,1.866l8.618,14.22A3.628,3.628,0,0,1,14.331,21.1Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.335 108.835)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2470.566,1711.917c.326-.231,1.068-.739,1.106-.625a.5.5,0,0,1-.1.364,3.2,3.2,0,0,1,1.98-.07.806.806,0,0,1,.53.349.356.356,0,0,1-.124.555c-.549.342-.39.137-1.154.634a2.247,2.247,0,0,1-2.257.275l-.75-.125-.093-1.233S2470.131,1711.99,2470.566,1711.917Z",
    transform: "translate(-2437.61 -1690.812)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2299.666,1591.686s1.767,2.1,4.018,1.219a6.833,6.833,0,0,0,.491-2.034c0-.106,0-.209,0-.307.012-.972.045-1.517.045-1.517h0c-.1-.043-3.44-1.413-3.437-1.3A5.92,5.92,0,0,1,2299.666,1591.686Z",
    transform: "translate(-2286.352 -1580.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M2312.8,1593.279a5.22,5.22,0,0,0,3.06,2.19c.012-.972.044-1.517.044-1.517h0A21.439,21.439,0,0,0,2312.8,1593.279Z",
    transform: "translate(-2298.032 -1585.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2308.3,1548.83s-3.753.882-4.267-1.464-1.344-3.812,1.031-4.474,3.038.13,3.4.871S2309.266,1548.54,2308.3,1548.83Z",
    transform: "translate(-2289.733 -1540.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2288.757,1533.192c-.052.033-.859.281-2.388-2.766a2.652,2.652,0,0,1,.156-2.427c.56-.914,2.544-1.633,4.193-1.946s2.044.615,2.433,1.547a5.035,5.035,0,0,0,1.585,1.785c-1.422.794-3.134-.342-3.727-.155s-.8,1.122-.847,1.421-.113.549-.859.281-.337,1.057-.218,1.311C2289.084,1532.243,2289.185,1532.918,2288.757,1533.192Z",
    transform: "translate(-2274.326 -1525.991)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2183.879,2075.663h-2.273c-.477,0-1.006-.477-1.138-1.35s-1.112-1.351-1.324-2.065.874-1.721.874-1.721l.182-.234.188-.243,1.8.424s.044.429.072.975a12.393,12.393,0,0,1,.007,1.25c-.053.954.267,1.98,1.114,2.166S2183.879,2075.663,2183.879,2075.663Z",
    transform: "translate(-2179.117 -2038.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2313.642,2094.458h-6.024a.518.518,0,0,1-.128-.037c-.4-.2-.276-1.741-.228-2.217.009-.088.016-.14.016-.14s2.118-1.694,2.41-.4c.009.04.02.081.031.119h0c.368,1.214,2.012,1.765,2.961,1.919A1.034,1.034,0,0,1,2313.642,2094.458Z",
    transform: "translate(-2293.058 -2057.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2282.1,1801.843s-.322,4.014-.7,8.839c-.514,6.555-1.132,14.605-1.194,16.13-.105,2.649-.53,6.885-.53,6.885a3.331,3.331,0,0,1-3.019.583,69.331,69.331,0,0,1-2.306-12.446c-.008-.1-.016-.21-.024-.316-.477-6.514-1.218-20.23-1.218-20.23Z",
    transform: "translate(-2262.727 -1799.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2282.1,1801.843s-.322,4.014-.7,8.839l-7.048,11.151c-.008-.1-.016-.21-.024-.316-.477-6.514-1.218-20.23-1.218-20.23Z",
    transform: "translate(-2262.727 -1799.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2204.274,1789.523s-5.8,14.537-9.612,21.369-5,8.738-5,8.738-2.184-.874-2.383-1.469c0,0,1.458-13.189,4.012-16.4,1.442-1.817,3.137-7.269,3.217-9.175s.516-5.68.516-5.68Z",
    transform: "translate(-2186.374 -1786.902)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.728 10.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2205.767,1783.968l-.062.935a2.014,2.014,0,0,1-1.111,2.513s-.74.3-.77-.277.065-.359,0-1.17a1.866,1.866,0,0,1,.795-1.835l.44-.508Z",
    transform: "translate(-2203.819 -1766.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2208.915,1644.043c.641.206.744.16.744.16s3.124-5.688,3.44-6.209,6.633-6.378,6.633-6.378l-1.623-6.053s-7.184,9.3-7.96,10.639c-1.282,2.206-2.033,7.329-2.033,7.329A1.881,1.881,0,0,0,2208.915,1644.043Z",
    transform: "translate(-2207.641 -1625.563)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2265.583,1623.426c-.022,1.243-.095,2.641-.192,4.06-.006.084-.012.168-.018.253-.062.879-.13,1.76-.208,2.62-.031.344-.064.685-.1,1.02l-.005.045c0,.125-.018.261-.032.385-.317,3.219-.649,5.762-.71,5.8a.362.362,0,0,1-.247.063,36.8,36.8,0,0,1-5.425-.363,15.635,15.635,0,0,1-4.826-2c-.211-.125-.691-.454-.652-.7.038-.271.109-.663.2-1.155a62.514,62.514,0,0,0,1.037-8.1q.053-.963.155-1.9a28.808,28.808,0,0,1,.841-4.537,8.961,8.961,0,0,1,3.506-5.216c.17-.1.63.445,1.471.986a3.267,3.267,0,0,0,2.31.2l.782,1.14a7.824,7.824,0,0,1,2,4.165q.027.207.048.44A27.324,27.324,0,0,1,2265.583,1623.426Z",
    transform: "translate(-2244.989 -1603.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2319.071,1667.829c-.022,1.243-.094,2.64-.192,4.06-.006.084-.012.168-.018.252a12.985,12.985,0,0,1-5.564-8.541,13.187,13.187,0,0,1,5.709,1.429A27.246,27.246,0,0,1,2319.071,1667.829Z",
    transform: "translate(-2298.477 -1648.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2314.475,1643.751c.05-.715-.321-.834-.321-.834s-7.27-1.317-7.888-1.512-5.9-5.692-5.9-5.692-2.025-2.284-3.684-1.78a3.118,3.118,0,0,0-2.2,2.634,3.155,3.155,0,0,0,1.465,3.238c2.481,1.521,7.448,4.52,8.618,4.863,2.6.763,9.6.061,9.6.061A2.251,2.251,0,0,0,2314.475,1643.751Z",
    transform: "translate(-2281.698 -1621.947)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.992 140.729)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 57.762,
    height: 33.802,
    transform: "translate(1.229)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.149,0H4.5a.15.15,0,0,1,.15.15V.8A.149.149,0,0,1,4.5.951H.15A.15.15,0,0,1,0,.8V.149A.149.149,0,0,1,.149,0Z",
    transform: "translate(0 1.817)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.714)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15,
    transform: "translate(0 1.817)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.427)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.149,0H4.5a.15.15,0,0,1,.15.15V.8a.15.15,0,0,1-.15.15H.15A.15.15,0,0,1,0,.8V.149A.149.149,0,0,1,.149,0Z",
    transform: "translate(0 1.817)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15,
    transform: "translate(0 1.817)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 26.855)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.15,0H4.5a.15.15,0,0,1,.15.15V.8A.149.149,0,0,1,4.5.951H.15A.15.15,0,0,1,0,.8V.15A.15.15,0,0,1,.15,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.652,
    height: 0.951,
    rx: 0.15,
    transform: "translate(0 1.817)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.118,0H323.96a.119.119,0,0,1,.119.119V.6a.119.119,0,0,1-.119.119H.119A.119.119,0,0,1,0,.6V.118A.118.118,0,0,1,.118,0Z",
    transform: "translate(5.777 174.442)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.354 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.188 59.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M3742.588,1363.9s-4.7-8.873,2.343-12.252c0,0,4.965-1.663,8.481-.646,0,0-6.954,7.331-5.51,8.541s7.159-8.727,7.159-8.727,10.162,1.273,13.016,3.53c0,0-10.067,5.045-8.37,5.862s12.417-3.945,12.417-3.945,8.9,3.657,7.138,9.192-5.346,6.562-6.714,6.1-8.864-5.441-9.3-4.333,3.654,5.973,7.072,6.926c0,0-8.146,5.729-12.015,2.676s-3.5-6.428-5.924-8.271-4.735-2.359-3.9-.849,5.45,3.835,6.381,6.918,1.9,5.239-2.432,3.554-10.891-6.609-10.364-10.44Z",
    transform: "translate(-3727.729 -1350.672)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.753)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M3740.638,1425.594s-24.922-6.625-32.092-.684a18.639,18.639,0,0,1-6.586,5.9l-.95,1.472s5.39-3.613,7.012-3.54C3708.021,1428.742,3707.586,1419.286,3740.638,1425.594Z",
    transform: "translate(-3693.687 -1422.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M3660.411,1476.393a16.182,16.182,0,0,0-8.272,9.823l.959.308s3.383-6.985,7.146-9.168S3660.411,1476.393,3660.411,1476.393Z",
    transform: "translate(-3652.139 -1468.02)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3508.679,1001s-17.1-8.919-9.633-21.938c0,0,6.045-8.037,12.715-10.257,0,0-3.02,19.172.582,19.514s1.826-21.606,1.826-21.606,17.466-9.051,24.439-8.585c0,0-10.436,18.944-6.86,18.389s15.35-19.764,15.35-19.764,18.068-3.906,21.3,6.774-1.313,16.2-3.985,16.956-19.949,1.044-19.433,3.273,12.284,5.471,18.729,3.259c0,0-6.65,17.933-16.1,17.317s-12.537-6.362-18.382-6.637-10.059,1.422-7.1,2.905,12.8.134,17.63,4,8.717,6.218.023,8.273-24.429,1.4-27.77-5.235Z",
    transform: "translate(-3497.158 -956.054)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.587 11.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M3602.887,1030.015s-46.648,16.655-51.523,33.862a35.805,35.805,0,0,1-4,16.508l.1,3.364s4.593-11.586,7.238-13.237C3554.7,1070.512,3543.721,1056.023,3602.887,1030.015Z",
    transform: "translate(-3543.43 -1030.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M3525.033,1353.926s-6.935,11.247-2.394,24.551l1.854-.558s-2.255-14.735,1.324-22.287S3525.033,1353.926,3525.033,1353.926Z",
    transform: "translate(-3521.097 -1303.556)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.449 103.834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2947.063,1662.877s-.16-14.422-11.369-13.847c0,0-7.405,1.312-11.141,5.008,0,0,13.805,4.473,12.815,6.99s-15.025-6.093-15.025-6.093-11.945,8.584-13.994,13.391c0,0,16.163-.549,14.583,1.647s-18.373,3.549-18.373,3.549-8.718,10.726-2.692,16.5,11.249,4.606,12.655,3.08,7.445-12.95,8.758-11.851-.509,10.043-4.165,13.592c0,0,14.208,1.634,16.994-4.874s0-10.512,1.794-14.5,4.352-6.227,4.338-3.75-4.241,8.58-3.3,13.108,1.2,7.916,5.509,2.814,9.2-15.815,5.906-20.288Z",
    transform: "translate(-2899.745 -1649.014)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.305 13.681)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2948.5,1763.4s26.89-25.47,40.013-22.9a26.768,26.768,0,0,0,12.36,2.92l2.21,1.2s-9.28-.857-11.275.348C2991.806,1744.972,2985.86,1732.746,2948.5,1763.4Z",
    transform: "translate(-2948.499 -1740.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M3285.829,1760.868a23.242,23.242,0,0,1,17.181,6.711l-1,1.048s-9.063-6.489-15.31-6.658S3285.829,1760.868,3285.829,1760.868Z",
    transform: "translate(-3233.455 -1757.767)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.96 48.278)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3000.319,1300.721s8.552-4.46,4.817-10.969c0,0-3.023-4.019-6.358-5.128,0,0,1.511,9.586-.291,9.757s-.912-10.8-.912-10.8-8.733-4.526-12.219-4.293c0,0,5.218,9.472,3.43,9.194s-7.675-9.882-7.675-9.882-9.034-1.953-10.653,3.387.657,8.1,1.992,8.478,9.975.522,9.718,1.637-6.143,2.736-9.365,1.629c0,0,3.325,8.967,8.048,8.658s6.269-3.181,9.191-3.318,5.03.711,3.548,1.453-6.4.067-8.815,2-4.358,3.109-.011,4.137,12.214.7,13.885-2.618Z",
    transform: "translate(-2969.898 -1278.248)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.659 5.541)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M3000.989,1315.23s23.324,8.328,25.762,16.931a17.9,17.9,0,0,0,2,8.254l-.05,1.683s-2.3-5.793-3.619-6.618C3025.082,1335.479,3030.572,1328.234,3000.989,1315.23Z",
    transform: "translate(-3000.989 -1315.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M3180.035,1477.185a15.539,15.539,0,0,1,1.2,12.276l-.927-.279s1.127-7.368-.662-11.143S3180.035,1477.185,3180.035,1477.185Z",
    transform: "translate(-3152.273 -1452)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.284 93.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M9.379,0H73.291a9.378,9.378,0,0,1,9.378,9.378v61.8a9.378,9.378,0,0,1-9.378,9.378H9.378A9.378,9.378,0,0,1,0,71.18V9.379A9.379,9.379,0,0,1,9.379,0Z",
    transform: "translate(9.983 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M8.976,0H73.691a8.977,8.977,0,0,1,8.977,8.977V68.137a8.978,8.978,0,0,1-8.978,8.978H8.977A8.977,8.977,0,0,1,0,68.138V8.976A8.976,8.976,0,0,1,8.976,0Z",
    transform: "translate(6.655 1.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 82.669,
    height: 80.557,
    rx: 11.354,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.133,
    height: 80.557,
    transform: "translate(67.263 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.688 39.714)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 96.617,
    height: 133.25,
    transform: "translate(2.488 1.567)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 96.617,
    height: 133.25,
    transform: "translate(0 1.567)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 83.364,
    height: 114.972,
    transform: "translate(6.626 10.706)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 36.702,
    height: 14.638,
    rx: 1.704,
    transform: "translate(29.957 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.626 15.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 6.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 12.084)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 18.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 24.168)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 30.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 36.252)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 42.294)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 48.336)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 6.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 12.084)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 18.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 24.168)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 30.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 36.252)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 42.294)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 83.364,
    height: 0.351,
    transform: "translate(0 48.336)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 121.863)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2862.662,1769.332V1822h-52.667v-52.668Z",
    transform: "translate(-2809.995 -1769.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2905.088,1769.331v9.954s.294,18.433.954,24.732c1.243,11.889,4.885,17.983,4.885,17.983h-52.81a41.991,41.991,0,0,1-5.7-17.2c-.737-6.336,0-25.515,0-25.515v-9.954Z",
    transform: "translate(-2845.784 -1769.331)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 52.668,
    height: 9.954,
    transform: "translate(6.636 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.148 62.196)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3345.2,1624.646l-.749-1.414s.371-2.519-2.785-4.112a1.541,1.541,0,0,0-1.805.471c-.6.867,1.144.71,1.051,2.192a2.726,2.726,0,0,0,1.589,2.835l.81.938Z",
    transform: "translate(-3331.905 -1601.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3385.51,1628.92a25,25,0,0,1-17.626,17.65c-4.656,1.356-15.234-13.972-15.234-13.972s.372-1.413,2.7-1.089c0,0,10.3,6.819,11.6,7.559,1.151.658,8.717-8.449,12.167-9.918A8.8,8.8,0,0,1,3385.51,1628.92Z",
    transform: "translate(-3342.387 -1608.836)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.786,
    height: 14.014,
    transform: "translate(3.009 2.754) rotate(-81.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3298.164,1618.014l3.009,1.872.422-2.754Z",
    transform: "translate(-3298.164 -1617.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0H2.786a0,0,0,0,1,0,0V1.379a.25.25,0,0,1-.25.25H.266A.266.266,0,0,1,0,1.363V0A0,0,0,0,1,0,0Z",
    transform: "translate(16.861 4.881) rotate(-81.269)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.352 50.194)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3592.778,2071.6s1.852,1.689,1.491,2.889-2.031,2-2.256,3.466-1.128,2.267-1.941,2.267H3586.2s-.6-1.032.847-1.343,1.988-2.034,1.9-3.634a28.361,28.361,0,0,1,.137-3.734l3.068-.71Z",
    transform: "translate(-3559.201 -2018.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3454.265,2091.829s.332,3.844-.481,4.244l-10.4-.022s0-1.2,1.67-1.467,4.6-1.244,5.1-3.421S3454.265,2091.829,3454.265,2091.829Z",
    transform: "translate(-3443.387 -2033.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3454.532,1805.982s.549,6.737,1.194,14.835c.875,11,1.929,24.512,2.034,27.072.179,4.445.9,11.554.9,11.554s1.714,1.689,5.145.977a114.661,114.661,0,0,0,3.931-20.888c.013-.176.028-.354.041-.531.813-10.932,2.076-33.952,2.076-33.952Z",
    transform: "translate(-3452.433 -1802.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3454.532,1805.982s.549,6.737,1.194,14.835l12.012,18.715c.013-.176.028-.354.041-.531.813-10.932,2.076-33.952,2.076-33.952Z",
    transform: "translate(-3452.433 -1802.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3467.829,1795.292s9.884,24.4,16.382,35.863,8.53,14.665,8.53,14.665,3.723-1.467,4.062-2.466c0,0-2.484-22.135-6.837-27.53-2.459-3.049-5.348-12.2-5.483-15.4s-.88-9.532-.88-9.532Z",
    transform: "translate(-3463.225 -1790.892)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3491.44,1579.708s-6.688,3.226-10.543,2.029a9.116,9.116,0,0,1,2.611-2.088c-.134-.773-.238-1.445-.3-2.015a18.613,18.613,0,0,1-.163-2.059l2.581-2.029,2.446-1.942A9.857,9.857,0,0,0,3491.44,1579.708Z",
    transform: "translate(-3446.479 -1562.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3451.715,1645.447a.6.6,0,0,0,.4.16c1.452-.03,5.678.773,9.251.408a27.307,27.307,0,0,0,8.556-2.423c.386-.175,1.262-.643,1.246-1.051-.015-.467-.059-1.124-.118-1.972-.12-1.668-.289-4.037-.343-6.844-.04-2.082-.018-4.405.135-6.866.008-.165.016-.332.023-.5.043-.9.065-1.81.065-2.7a46.971,46.971,0,0,0-.606-8.03c-.729-4.235-2.093-7.548-4.108-9.024-.267-.205-1.929.6-3.471,1.343a6.411,6.411,0,0,1-4.151.5l-1.334,1.168a13.183,13.183,0,0,0-4.184,6.57,73.051,73.051,0,0,0-1.245,12.177c-.1,2.219-.178,4.438-.208,6.554v.073c-.015.219-.015.439-.015.659C3451.538,1641.065,3451.61,1645.374,3451.715,1645.447Z",
    transform: "translate(-3422.686 -1591.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3497.384,1582.061a8.859,8.859,0,0,1-4.908,3.942,18.664,18.664,0,0,1-.163-2.059l2.581-2.029Z",
    transform: "translate(-3455.746 -1571.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3480.7,1547.432s6.379,1.044,6.978-2.878,1.827-6.429-2.222-7.261-5.069.547-5.594,1.808S3479.058,1547.059,3480.7,1547.432Z",
    transform: "translate(-3445.312 -1534.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3481.114,1526.556c.058-.067.191-.12.489-.137a1.208,1.208,0,0,0-.556-.156,1.493,1.493,0,0,0-.993-1.323.894.894,0,0,1,.433.643c-.824-.846-2.59-1.462-7.48-1.076-6.443.508-4.32,4.634-3.485,5.126s2.934-.857,4.488-.733,1.85,2.369,2.376,2.677.32-.237,1.034-.559.782.86.575,1.628.775,1.782.775,1.782l.99-1.067c.991-1.067,1.925-5.586,1.475-6.548Z",
    transform: "translate(-3436.426 -1524.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3356.21,1630s.22-.867-.382-1.257-1.154-1.45-1.408-1.306c-.526.3.287,1.222.138,2.376C3354.507,1630.219,3355.447,1631.277,3356.21,1630Z",
    transform: "translate(-3343.679 -1608.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3536.3,1694.175c-.04-2.082-.017-4.405.134-6.866.009-.165.017-.332.023-.5-.606-3-1.523-5.67-2.873-5.757C3533.586,1681.054,3529.563,1687.376,3536.3,1694.175Z",
    transform: "translate(-3488.279 -1651.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3563.693,1805.718a20.3,20.3,0,0,1-.7,3.876,13.89,13.89,0,0,1-2.6,2.974c-.667.387.408-2.6.271-3.177s-.548,1.06-.841,1.1-.219-1.437-.229-1.974,1.43-1.863,1.939-3.007S3563.693,1805.718,3563.693,1805.718Z",
    transform: "translate(-3510.349 -1752.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3516.108,1606.575s4.036,1.912,5.972,4.85c3,4.558,6.481,21.17,6.546,22.708s-2.54,12.4-2.54,12.4-2.642-.174-3.322-1.507c0,0,.528-11.158.194-11.875s-11.012-14.969-9.811-18.01S3516.108,1606.575,3516.108,1606.575Z",
    transform: "translate(-3472.579 -1591.096)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.575a2287e42987efcb743334c7582282.svg";
export { ForwardRef as ReactComponent };